import { render } from "./Reviews.vue?vue&type=template&id=942e3d68&ts=true&lang=pug"
import script from "./Reviews.vue?vue&type=script&setup=true&lang=ts"
export * from "./Reviews.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__